// =============================================================
// highlevelReviewsService
// Service layer for HighLevel Reputation / Reviews API.
// Live mode (future): reputation endpoints + review request workflows.
// v1: mock JSON.
// =============================================================

import { REVIEWS } from "../data/mockData";

const LIVE_API_ENABLED = false;
const simulateLatency = (data, ms = 120) => new Promise((res) => setTimeout(() => res(data), ms));

export const highlevelReviewsService = {
  isLive: () => LIVE_API_ENABLED,

  async getReputationSnapshot() {
    return simulateLatency({ ...REVIEWS });
  },

  /** Queue a review request for a contact (mock) */
  async sendReviewRequest(contactId) {
    return simulateLatency({ ok: true, contactId, status: "queued" });
  },

  /** Queue a referral invite for a contact (mock) */
  async sendReferralInvite(contactId) {
    return simulateLatency({ ok: true, contactId, status: "queued" });
  },
};
